export default [
  [`Размеры`, `5XS`, `4XS`, `3XS`, `2XS`, `XS`, `S`],
  [`Возраст, лет`, `3-4`, `5-6`, `7-8`, `9-10`, `11-12`, `13-14`],
  [`Рост, см`, `98-104`, `110-116`, `122-128`, `134-140`, `146-152`, `158-164`],
  [`Полуобхват в груди, см`, `31`, `34`, `37`, `40`, `43`, `46`],
  [`Длина, см`, `45`, `48`, `51`, `54`, `57`, `60`]
];
